module.exports = __webpack_public_path__ + "static/img/LbTu2@2x.24ecaf00.png";